import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip"

export const TooltipWrapper = ({ children, content, side, className }: { children: React.ReactNode, content: React.ReactNode, side: "top" | "right" | "bottom" | "left" | undefined, className?: string }) => {
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild={true}>{children}</TooltipTrigger>
                <TooltipContent avoidCollisions={true} side={side} className={`bg-card text-card-foreground border shadow ${className}`}>
                    <div>
                        {content}
                    </div>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    )

}